<template>
  <div class="c-serviceSearchHeaderFacetSelectedItem">
    <CButton
      class="c-serviceSearchHeaderFacetSelectedItem_button"
      @click="clearFacet()"
    >
      <slot
        v-for="slotName in Object.keys($slots)"
        :name="slotName"
        :slot="slotName"
      />
      <CoconalaIcon
        class="c-serviceSearchHeaderFacetSelectedItem_closeIcon"
        name="times-circle"
        size="12px"
        color="gray600"
      />
    </CButton>
  </div>
</template>
<script>
export default {
  name: 'ServiceSearchHeaderFacetSelectedItem',
  props: {
    itemValue: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    clearFacet() {
      this.$emit('clear-facet', this.itemValue)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-serviceSearchHeaderFacetSelectedItem {
  margin-top: 8px;
  &_button {
    /deep/ &.button {
      padding: 4px 8px;
      background: $color-gray-50;
      border: 1px solid $color-gray-300;
      box-sizing: border-box;
      border-radius: 15.5px;
      color: $color-gray-900;
      width: auto;
      height: auto;
      font-size: 12px;
      line-height: 18px;

      > span {
        display: inline-flex;
        align-items: center;
      }

      &:hover {
        @include link-effect;
      }
    }
  }
  &_closeIcon {
    margin-left: 4px;
    display: inline-flex;
  }
}
</style>
